import axios from '@/api/axiosInstance';

export default async function submitSurveyResponse({ code, answers }) {
  const normalizedAnswers = Array.isArray(answers) ? answers : [answers];

  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/teacher/surveys`,
    method: 'post',
    data: { code, answers: normalizedAnswers },
  });
  return response.data;
}
